var React = require('react');

function Flag (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M9.8,1.9L9.4,0H0.9v16h1.9V9.4h5.3l0.4,1.9h6.6V1.9H9.8z","fill":"currentColor"}));
}

Flag.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Flag;

Flag.default = Flag;
